import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 10v7","key":"svg-0"}],["path",{"d":"M5 12a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2l0 -3","key":"svg-1"}],["path",{"d":"M14 20v-11a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2","key":"svg-2"}]]

const IconAlphabetGreek = createReactComponent('outline', 'alphabet-greek', 'AlphabetGreek', __iconNode);

export default IconAlphabetGreek;